module.exports = __webpack_public_path__ + "assets/img/map_rakumart.80e24565.svg";